<button 
	[class]="'btn btn-' + buttonType + ' ' + classes" 
	[type]="type" 
	[disabled]="disabled" 
	[ngClass]="{ 'btn-block': block, 'btn-sm': small }"
	[style]="style" 
	(click)="clickEvent()">
	<ng-content></ng-content>
</button>